import React from "react";
import ReactDOM from "react-dom/client";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./index.css";
import AdminAlertContent from "./pages/admin/alert-content/List";
import Coupon from "./pages/admin/coupon/List";
import EmailMKT from "./pages/admin/email-mkt/List";
import ESIndex from "./pages/admin/es-index/List";
import AdminHomePage from "./pages/admin/Home";
import AdminPlan from "./pages/admin/plan/Plan";
import AdminCourses from "./pages/admin/courses/List";
import AdminSetting from "./pages/admin/settings/Setting2";
import Slide from "./pages/admin/slide/List";
import AdminVideos from "./pages/admin/video/List";
import ModerationPosts from "./pages/admin/community/ModerationPosts";
import ModerationComments from "./pages/admin/community/ModerationComments";
import AdminSubscriptions from "./pages/admin/subscription/Subscription";
import AdminTransaction from "./pages/admin/transaction/Transaction";
import Users from "./pages/admin/user/User";
import ManagePrompts from "./pages/admin/prompts/ManagePrompts";
import AdminStatusIncidents from "./pages/admin/status/Incidents";
import AdminStatusComponents from "./pages/admin/status/Components";
import AdminStatusSubscribers from "./pages/admin/status/Subscribers";
import AdminFeedback from "./pages/admin/feedback/Feedback";
import CoursePlayer from "./pages/course/Player";
import CourseList from "./pages/course/List";
import VideoSlides from "./pages/video/VideoSlides";
import PrayerList from "./pages/community/PrayerList";
import PraiseList from "./pages/community/PraiseList";
import CommunityLayout from "./components/Layout/CommunityLayout";
import MySubmissions from "./pages/community/MySubmissions";
import PrayerDetail from "./pages/community/PrayerDetail";
import PraiseDetail from "./pages/community/PraiseDetail";

import GoogleAuthHandleRedirect from "./components/Auth/GoogleAuthHandleRedirect";

import { AuthMiddleware } from "./components/Auth/AuthMiddleware";
import SubscriptionLayout from "./components/Layout/Subscription";
import NewChat from "./components/NewChat/NewChat";
import ScrollChat from "./components/NewChat/ScrollChat/ScrollChat";
import QAPage from "./pages/frequently-asked-questions/index";
import LandingPage from "./pages/index";
import ForgotPassword from "./pages/login/ForgotPassword";
import LoginForm from "./pages/login/Login2";
import Privacy from "./pages/policy/Policy";
import Term from "./pages/policy/Term";
import Share from "./pages/share/Share";
import SignupForm from "./pages/signup/Signup2";
import VerifyEmail from "./pages/signup/VerifyEmail";
import VerifyNotify from "./pages/signup/VerifyNotify";
import Subscriptions from "./pages/subscription/Subscription";
import SubscriptionSuccess from "./pages/subscription/Success";
import StatusPage from "./pages/status/StatusPage";

import store from "./store";
import { configAxiosDefault } from "./utils/axios";

configAxiosDefault();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <HelmetProvider>
      <Helmet>
        <title>Gospel Truth AI</title>
        <meta name="description" content="Gospel Truth AI" />
        <link rel="canonical" href={process.env.REACT_APP_DOMAIN} />
      </Helmet>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />}>
              <Route index element={<NewChat />} />
          </Route>
          <Route path="/home" element={<AuthMiddleware component={<App />} />}>
            <Route index element={<NewChat />} />
            <Route path="app" element={<ScrollChat />}></Route>
            <Route path="app/:historyId" element={<ScrollChat />}></Route>
            <Route path="courses" element={<CourseList />} />
            <Route path="courses/:courseId/player" element={<CoursePlayer />} />
            <Route path="videoslides" element={<VideoSlides />} />
          </Route>
          <Route path="/prayers" element={<CommunityLayout />}>
            <Route index element={<PrayerList />} />
            <Route path=":id" element={<PrayerDetail />} />
          </Route>
          <Route path="/praise" element={<CommunityLayout />}>
            <Route index element={<PraiseList />} />
            <Route path=":id" element={<PraiseDetail />} />
          </Route>
          <Route path="/me/submissions" element={<AuthMiddleware component={<CommunityLayout />} />}>
            <Route index element={<MySubmissions />} />
          </Route>
          <Route
            path="/admin"
            element={<AuthMiddleware component={<AdminHomePage />} />}
          >
            <Route path="" element={<Users />} />
            <Route path="user" element={<Users />} />
            <Route path="plan" element={<AdminPlan />} />
            <Route path="subscription" element={<AdminSubscriptions />} />
            <Route path="transaction" element={<AdminTransaction />} />
            <Route path="setting" element={<AdminSetting />} />
            <Route path="alert-content" element={<AdminAlertContent />} />
            <Route path="email-mkt" element={<EmailMKT />} />
            <Route path="es-index" element={<ESIndex />} />
            <Route path="slide" element={<Slide />} />
            <Route path="video" element={<AdminVideos />} />
            <Route path="coupon" element={<Coupon />} />
            <Route path="courses" element={<AdminCourses />} />
            <Route path="prompts" element={<ManagePrompts />} />
            <Route path="community/posts" element={<ModerationPosts />} />
            <Route path="community/comments" element={<ModerationComments />} />
            <Route path="status/incidents" element={<AdminStatusIncidents />} />
            <Route path="status/components" element={<AdminStatusComponents />} />
            <Route path="status/subscribers" element={<AdminStatusSubscribers />} />
            <Route path="feedback" element={<AdminFeedback />} />
          </Route>
          <Route
            path="/return/auth/google"
            element={<GoogleAuthHandleRedirect />}
          />

          <Route path="/term" element={<SubscriptionLayout hideLogin={true} />}>
            <Route path="privacy-policy" element={<Privacy />} />
            <Route path="terms-of-service" element={<Term />} />
          </Route>

          <Route path="/reset-password" element={<ForgotPassword />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/signup" element={<SignupForm />} />
          <Route path="/email-verification" element={<VerifyEmail />} />
          <Route path="/ask-verification" element={<VerifyNotify />} />
          <Route
            path="/share"
            element={<SubscriptionLayout hideLogin={true} />}
          >
            <Route path=":messageId" element={<Share />}></Route>
          </Route>
          <Route
            path="/frequently-asked-questions"
            element={<SubscriptionLayout hideLogin={true} />}
          >
            <Route path="" element={<QAPage />}></Route>
          </Route>

          <Route path="/courses" element={<Navigate to="/home/courses" replace />} />
          <Route path="/courses/:courseId/player" element={<Navigate to="/home/courses/:courseId/player" replace />} />

          <Route path="/subs/thank-you" element={<SubscriptionSuccess />} />

          <Route path="/status" element={<StatusPage />} />

          <Route
            path="/subs"
            element={<AuthMiddleware component={<SubscriptionLayout />} />}
          >
            <Route path="" element={<Subscriptions />}></Route>
          </Route>
        </Routes>
        <ToastContainer />
      </BrowserRouter>
    </HelmetProvider>
  </Provider>
);
